'use es6';

import * as UnifiedDataTypes from '../../constants/dataTypes/unified';
export const get = dataType => Object.prototype.hasOwnProperty.call(UnifiedDataTypes, dataType);